import { BadgeProps, Badge as ChakraBadge } from '@chakra-ui/react'

export interface Props extends BadgeProps {}

export default function Badge(props: Props) {
  return <ChakraBadge textStyle="labelSmall" {...props} />
}
